export default "__VITE_ASSET__BlMiimqz__"